function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFC255"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA039"
    },
    d: "M424.193,353.58H75.807c-1.475,0-2.67-1.195-2.67-2.67l0,0c0-1.475,1.195-2.67,2.67-2.67h348.387 c1.475,0,2.67,1.195,2.67,2.67l0,0C426.863,352.384,425.668,353.58,424.193,353.58z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA039"
    },
    d: "M278.172,150.271h-77.963c-1.134,0-2.054-0.92-2.054-2.054V93.286 c0-1.134,0.919-2.054,2.054-2.054h77.963c1.134,0,2.054,0.92,2.054,2.054v54.931 C280.226,149.352,279.306,150.271,278.172,150.271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC255"
    },
    d: "M271.229,143.775h-64.077c-1.134,0-2.054-0.919-2.054-2.054v-41.94 c0-1.134,0.92-2.054,2.054-2.054h64.077c1.134,0,2.054,0.92,2.054,2.054v41.94 C273.283,142.856,272.364,143.775,271.229,143.775z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFA039",
      strokeWidth: 1.6235,
      strokeMiterlimit: 10
    },
    d: "M225.167,94.038l12.193-12.193 c1.011-1.011,2.65-1.011,3.661,0l12.193,12.193"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA039"
    },
    d: "M185.193,181.761h-77.963c-1.134,0-2.054-0.92-2.054-2.054v-54.932 c0-1.134,0.92-2.054,2.054-2.054h77.963c1.134,0,2.054,0.92,2.054,2.054v54.932 C187.247,180.842,186.328,181.761,185.193,181.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC255"
    },
    d: "M178.25,175.266h-64.077c-1.134,0-2.054-0.92-2.054-2.054v-41.94 c0-1.134,0.92-2.054,2.054-2.054h64.077c1.134,0,2.054,0.92,2.054,2.054v41.94C180.304,174.346,179.385,175.266,178.25,175.266 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFA039",
      strokeWidth: 1.6235,
      strokeMiterlimit: 10
    },
    d: "M132.188,125.528l12.193-12.193 c1.011-1.011,2.65-1.011,3.661,0l12.193,12.193"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA039"
    },
    d: "M411.098,219.162h-77.963c-1.134,0-2.054-0.92-2.054-2.054v-54.932 c0-1.134,0.92-2.054,2.054-2.054h77.963c1.134,0,2.054,0.919,2.054,2.054v54.932 C413.152,218.242,412.233,219.162,411.098,219.162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC255"
    },
    d: "M404.155,212.666h-64.077c-1.134,0-2.054-0.919-2.054-2.054v-41.94 c0-1.134,0.919-2.054,2.054-2.054h64.077c1.134,0,2.054,0.92,2.054,2.054v41.94 C406.209,211.746,405.29,212.666,404.155,212.666z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFA039",
      strokeWidth: 1.6235,
      strokeMiterlimit: 10
    },
    d: "M358.093,162.928l12.193-12.193 c1.011-1.011,2.65-1.011,3.661,0l12.193,12.193"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFA039"
    },
    cx: 250,
    cy: 407.9,
    rx: 169.02,
    ry: 11.014
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 259.448,
    y: 330.15,
    style: {
      fill: "#FFFFFF"
    },
    width: 16.55,
    height: 77.75
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D2E2FF"
    },
    points: "275.998,336.7 275.998,348.24 259.448,345.19 259.448,336.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D2E2FF"
    },
    points: "275.998,385.346 275.998,396.886 259.448,393.836 259.448,385.346  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95BAEF"
    },
    d: "M278.4,389.441h-21.354c-3.633,0-6.578,2.945-6.578,6.578v0c0,3.633,2.945,6.578,6.578,6.578 H278.4c3.633,0,6.578-2.945,6.578-6.578v0C284.978,392.387,282.033,389.441,278.4,389.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95BAEF"
    },
    d: "M278.4,328.931h-21.354c-3.633,0-6.578,2.945-6.578,6.578v0c0,3.633,2.945,6.578,6.578,6.578 H278.4c3.633,0,6.578-2.945,6.578-6.578v0C284.978,331.877,282.033,328.931,278.4,328.931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2E2FF"
    },
    d: "M287.255,394.743H248.19c-3.633,0-6.578,2.945-6.578,6.578l0,0c0,3.633,2.945,6.578,6.578,6.578 h39.066c3.633,0,6.578-2.945,6.578-6.578l0,0C293.834,397.688,290.888,394.743,287.255,394.743z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#6B6BC6"
    },
    points: "354.85,212.005 298.169,212.005 258.276,324.871 314.85,319.254 344.978,261.382  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2E2FF"
    },
    d: "M365.198,222.34c0,1.2-0.21,2.41-0.65,3.6l-37.96,102.42c-1.1,2.96-3.4,5.11-6.15,6.11 c-0.01,0.01-0.03,0.02-0.04,0.02c-1.35,0.65-2.87,1.02-4.48,1.02h-121.79c-5.71,0-10.34-4.63-10.34-10.34 c0-2.86,1.16-5.45,3.03-7.31c1.87-1.88,4.46-3.03,7.31-3.03h115.42l35.61-96.08c1.99-5.35,7.94-8.08,13.29-6.1 C362.617,214.2,365.198,218.15,365.198,222.34z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C43364"
    },
    d: "M223.228,377.86l-57.93,29.4c-0.85,0.43-1.76,0.64-2.65,0.64c-2.13,0-4.19-1.17-5.22-3.21 c-0.94-1.84-0.84-4.04,0.27-5.79l9.73-15.37l4.24-6.7l45.81-23.25l7.06,13.91l1.26,2.49 C227.268,372.87,226.117,376.4,223.228,377.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48215B"
    },
    d: "M202.472,324.275l0.8,4.32l6.3,33.81l-29.9,14.95l-12.31,6.15l-18.25-61.73 c-4.7-15.92,7.23-31.88,23.83-31.88h71.35l-0.85,34.38H202.472z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3B184F"
    },
    points: "203.272,328.595 209.572,362.405 179.672,377.355  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 170.574,
    y1: 374.149,
    x2: 204.277,
    y2: 356.532
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3B184F"
    },
    points: "244.292,289.895 243.442,324.275 205.362,324.275 222.012,289.895  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M189.11,364.46l-10.285-44.278 c-1.727-7.437,3.919-14.546,11.554-14.546h50.429"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48215B"
    },
    d: "M312.212,267.545v19.92c0,14.99-12.05,27.16-26.99,27.35c-0.12,0.01-0.25,0.01-0.37,0.01h-11.69 l-32.35,69.45h-51.37l39.88-93.45l-0.259-23.28H312.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B184F"
    },
    d: "M285.222,295.752v19.063c-0.004,0.004-0.006,0.006-0.01,0.01h-12.05l9.175-19.712 C283.021,293.645,285.222,294.132,285.222,295.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M226.436,377.355l30.233-65.09 c4.626-9.959,14.61-16.33,25.591-16.33h18.888"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2517F"
    },
    d: "M240.808,384.28v18.39c0,0.35-0.03,0.68-0.09,1.01c-0.48,2.76-2.88,4.85-5.77,4.85h-64.96 c-1.62,0-3.09-0.65-4.15-1.71c-0.83-0.83-1.41-1.92-1.62-3.14c-0.06-0.33-0.09-0.66-0.09-1.01c0-2.06,1.09-3.98,2.86-5.03 l22.45-13.36H240.808z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.25,
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 170.319,
    y1: 401.322,
    x2: 234.83,
    y2: 401.322
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48215B"
    },
    d: "M150.361,274.298c-9.191,7.596-6.319,12.702-6.319,12.702h23.745l-4.681-10.979l-5.532-2.007"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCCCC"
    },
    d: "M207.531,203.718l-13.277,50.213c0,0-39.709,9.361-46.128,12.255 c-3.255,1.468-9.638,12.255-8.234,15.511c1.404,3.255,6.064,0.511,6.064,0.511s3.447,4.525,7.404,1.082 c4.213,2.429,8.298,4.216,10.213-2.996l52.851-10.42l22.766-56.282L207.531,203.718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F97594",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M145.957,282.208 c3.064-9.043,7.277-12.83,8.809-13.511"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F97594",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M153.361,283.289 c0.809-5.528,6.426-11.911,9.745-12.933"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M280.446,151.633l34.1,13.041c9.233,3.531,15.971,11.601,17.798,21.315l3.527,18.75l-23.66,6.468 v56.34h-84.426v-56.511l-20.255-7.319l7.87-23.716c2.958-8.913,10.122-15.792,19.148-18.385l26.913-7.732L280.446,151.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B3CBFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M250.152,244.995 c29.164,3.319,35.071-16.851,35.071-16.851"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F97594"
    },
    d: "M267.701,252.74c-3.149,4-14.298,5.872-13.191,9.277c1.106,3.404,10.894,2.213,15.149-0.851"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCCCC"
    },
    d: "M334.708,243.58c-0.15,0.92-0.31,1.8-0.5,2.63c-0.45,1.97-0.98,3.65-1.62,4.91 c-0.99,1.96-2.95,3.59-5.46,4.94c-0.48,0.26-0.98,0.51-1.5,0.75c-10.78,5-29.1,5.86-29.1,5.86s-1.41,5.3-3,11.3 c-1.6,6-3.77,9.96-8.62,8.36c-4.74-1.55,0.89-19.35,1.14-20.14c-0.23,0.46-3.45,6.94-5.48,10.63c-2.1,3.83-4.85,10.09-9.25,7.09 c-4.18-2.84,0.58-14.77,1.1-16.04c-0.66,1.21-6.73,12.45-9.04,14.32c-2.45,1.97-5.53-1.28-5.34-3.2 c0.19-1.91,5.43-21.76,10.15-23.8c4.72-2.05,39.64-15.13,39.64-15.13l-3.83-23.49l31.87-7.83 C335.867,204.74,337.107,229.25,334.708,243.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F97594"
    },
    d: "M334.708,243.58c-0.15,0.92-0.31,1.8-0.5,2.63c-0.45,1.97-0.98,3.65-1.62,4.91 c-0.99,1.96-2.95,3.59-5.46,4.94c-0.48,0.26-0.98,0.51-1.5,0.75C326.448,251.12,329.898,246.29,334.708,243.58z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#F97594",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 307.832,
    y1: 236.061,
    x2: 320.893,
    y2: 231.293
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F97594",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M270.445,269.872 c3.724-11.26,5.426-13.811,5.426-13.811"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F97594",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M283.134,275.381 c0.312-10.386,4.142-16.973,4.142-16.973"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F97594",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M270.106,252.74 c2.043-1.234,2.617,1.191,2.617,1.191"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F97594",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M280.473,255.451 c1.862-1.493,2.751,0.836,2.751,0.836"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F97594",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M291.3,258.907 c1.862-1.493,2.751,0.836,2.751,0.836"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B3CBFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 304.002,
    y1: 212.571,
    x2: 301.148,
    y2: 192.825
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B3CBFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 227.786,
    y1: 211.038,
    x2: 227.786,
    y2: 189.591
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B3CBFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M256.609,155.28 c0,0-1.352,11.407,11.078,12.354c12.43,0.946,21.476-8.787,21.298-12.734"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E8EF4"
    },
    d: "M245.97,126.238v5.24c0,2.62,1.66,4.86,3.99,5.71c0.65,0.24,1.36,0.37,2.09,0.37h1.32 c2.15,0,3.9-1.75,3.9-3.9v-9.6c0-2.15-1.75-3.9-3.9-3.9h-1.32c-0.73,0-1.44,0.13-2.09,0.37 C247.63,121.378,245.97,123.618,245.97,126.238z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48215B"
    },
    d: "M295.912,121.966c-3.66,9.36-10.81,21.27-17.79,18.55l-26.4-21.75 c-9.46-3.46-9.47-9.55-7.73-11.44l0.09-0.09c1.75-1.71,5.77-0.14,6.1-0.01c-0.4-0.35-6.64-5.82-3.49-9.69 c2.84-3.49,7.16-0.69,8.21,0.08c-0.79-0.65-3.21-2.97-1.59-5.95c1.91-3.53,10.04,1.62,17.53,2.81 c7.49,1.19,18.68,2.21,20.73,6.3c2.04,4.08,0,8.34,0,8.34s1.95,0.85,3.48,2.83C296.622,113.986,297.772,117.226,295.912,121.966 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B194F"
    },
    d: "M295.912,121.966c-3.66,9.36-10.81,21.27-17.79,18.55l-26.4-21.75 c-9.46-3.46-9.47-9.55-7.73-11.44c7.97,6.78,33.61,8.47,38.6,7.49c5.19-1.02,2.92-9.17,2.92-9.17l2.67,1.17 c0,0,4.25,9.26,6.87,5.13C296.622,113.986,297.772,117.226,295.912,121.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCCCC"
    },
    d: "M283.122,154.926c-0.89,2.87-8.8,7.53-14.61,6.95c-5.81-0.57-6.77-3.44-6.77-3.44l-0.28-4.55 l-0.36-5.92l15.44-6.74l5.18-2.26L283.122,154.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F97594"
    },
    d: "M281.152,140.686c-0.07,1.9-7.53,12.72-19.69,13.2l-0.36-5.92l15.44-6.74 C279.332,140.506,281.162,140.206,281.152,140.686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCCCC"
    },
    d: "M251.12,114.182c-1.787,7.213-0.419,10.868-0.866,15.208c-0.447,4.34,0.064,18.383,12.128,20.298 c12.064,1.915,21.915-10.362,22.979-15.324c2.617,3,6.606-2.074,6.096-4.691c-0.511-2.617-2.011-3.032-3.574-2.33 c-1.564,0.702-2.17,3.702-2.649,3.542c-0.479-0.16-1.56-11.915-1.56-11.915S262.354,119.862,251.12,114.182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F97594",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M262.042,128.006l-1.515,4.609c-0.293,0.892,0.178,1.855,1.063,2.171l1.389,0.496"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M270.009,138.672c0.2,2.141-1.374,4.039-3.515,4.238c-2.141,0.2-4.039-1.374-4.238-3.515"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48215B"
    },
    d: "M272.101,127.581c0,0.705-0.572,1.277-1.277,1.277c-0.705,0-1.277-0.572-1.277-1.277 c0-0.705,0.572-1.277,1.277-1.277C271.53,126.304,272.101,126.876,272.101,127.581z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#48215B"
    },
    cx: 255.42,
    cy: 127.581,
    r: 1.277
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#48215B",
      strokeWidth: 0.8719,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M268.112,123.126c0,0,2.705-1.342,5.357,0.363"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#48215B",
      strokeWidth: 0.8719,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M258.099,123.126c0,0-2.705-1.342-5.357,0.363"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#274CC1"
    },
    d: "M287.34,120.709c0,0,3.492-25.926-19.573-26.91c0,0,6.348-1.469,12.961,2.22 c6.613,3.69,11.123,9.258,9.953,26.165"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E8EF4"
    },
    d: "M295.192,126.236v5.24c0,2.62-1.66,4.86-3.99,5.71c-0.65,0.24-1.36,0.37-2.09,0.37h-1.32 c-0.47,0-0.93-0.09-1.35-0.25c-1.49-0.54-2.55-1.98-2.55-3.65v-9.6c0-1.67,1.06-3.11,2.55-3.65c0.42-0.16,0.88-0.25,1.35-0.25 h1.32c0.73,0,1.44,0.13,2.09,0.37C293.532,121.376,295.192,123.616,295.192,126.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A4DCFF"
    },
    d: "M294.723,126.632v4.451c0,1.952-1.085,3.656-2.687,4.533c-0.429,0.234-0.972,0.218-1.355-0.085 c-0.767-0.606-1.258-1.545-1.258-2.596v-8.155c0-1.051,0.492-1.99,1.258-2.596c0.383-0.303,0.927-0.319,1.355-0.085 C293.638,122.976,294.723,124.68,294.723,126.632z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#274CC1"
    },
    cx: 286.701,
    cy: 131.804,
    r: 1.479
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#48215B",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M286.701,131.804 l-4.962,5.251c-1.029,1.089-2.462,1.707-3.961,1.707h-3.588"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48215B"
    },
    d: "M274.761,140.298h-1.523c-0.849,0-1.536-0.688-1.536-1.536l0,0c0-0.849,0.688-1.536,1.536-1.536 h1.523c0.849,0,1.536,0.688,1.536,1.536l0,0C276.297,139.61,275.609,140.298,274.761,140.298z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0BBFF"
    },
    d: "M375.357,293.38c0,1.76-0.71,3.36-1.87,4.51c-1.15,1.16-2.75,1.87-4.51,1.87h-76.34 c1.76,0,3.36-0.71,4.51-1.87c1.16-1.15,1.87-2.75,1.87-4.51c0-3.52-2.85-6.38-6.38-6.38h76.34 C372.508,287,375.357,289.86,375.357,293.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M299.018,293.38c0,1.76-0.71,3.36-1.87,4.51c-1.15,1.16-2.75,1.87-4.51,1.87h-171.06 c-3.53,0-6.39-2.85-6.39-6.38c0-1.76,0.71-3.36,1.87-4.51c1.16-1.15,2.76-1.87,4.52-1.87h171.06 C296.168,287,299.018,289.86,299.018,293.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M103.766,408.275L103.766,408.275c-2.046,0-3.464-2.041-2.75-3.958l38.934-104.557h6.263 l-39.696,106.605C106.088,407.513,104.992,408.275,103.766,408.275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M315.479,408.275L315.479,408.275c2.046,0,3.464-2.041,2.75-3.958L279.295,299.76h-6.263 l39.696,106.605C313.156,407.513,314.253,408.275,315.479,408.275z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M378.893,408.275L378.893,408.275c2.046,0,3.464-2.041,2.75-3.958L342.71,299.76h-6.263 l39.696,106.605C376.571,407.513,377.668,408.275,378.893,408.275z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9061F7"
    },
    d: "M303.313,280.786h-72.084c-1.716,0-3.107,1.391-3.107,3.107l0,0 c0,1.716,1.391,3.107,3.107,3.107h72.084c1.716,0,3.107-1.391,3.107-3.107l0,0C306.42,282.177,305.029,280.786,303.313,280.786 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D2C5FF",
      strokeMiterlimit: 10
    },
    d: "M265.882,263.741h-86.511c-1.445,0-2.929-1.172-3.315-2.617 l-14.644-54.895c-0.385-1.445,0.474-2.617,1.919-2.617h86.511c1.445,0,2.93,1.172,3.315,2.617l14.644,54.895 C268.186,262.57,267.327,263.741,265.882,263.741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFF2BE",
      strokeMiterlimit: 10
    },
    d: "M193.989,245.8h-52.106c-0.871,0-1.765-0.706-1.997-1.576 l-8.82-33.064c-0.232-0.871,0.285-1.576,1.156-1.576h52.106c0.871,0,1.764,0.706,1.997,1.576l8.82,33.064 C195.377,245.094,194.86,245.8,193.989,245.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A888FF"
    },
    d: "M247.796,287h-86.511c-1.445,0-2.93-1.172-3.315-2.617l-14.643-54.895 c-0.386-1.445,0.473-2.617,1.919-2.617h86.511c1.445,0,2.93,1.172,3.315,2.617l14.644,54.895 C250.101,285.828,249.242,287,247.796,287z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#592BA3"
    },
    cx: 259.446,
    cy: 283.893,
    r: 1.17
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D2E2FF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M259.446,283.893 c2.638,11.106-8.426,46.554-37.192,44.702c-28.766-1.852-19.064-15.469-40-18.022c-20.936-2.553-32.346-11.8-29.958-25.152"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#592BA3"
    },
    cx: 263.084,
    cy: 283.893,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#592BA3"
    },
    cx: 266.723,
    cy: 283.893,
    r: 1.17
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#592BA3"
    },
    d: "M280.957,284.637h-9.915c-0.411,0-0.745-0.333-0.745-0.745l0,0c0-0.411,0.333-0.745,0.745-0.745 h9.915c0.411,0,0.745,0.333,0.745,0.745l0,0C281.701,284.304,281.368,284.637,280.957,284.637z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6729 -0.7397 0.7397 0.6729 -126.1963 228.463)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 195.25,
    cy: 256.935,
    rx: 5.748,
    ry: 6.945
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36BEC1"
    },
    d: "M369.828,319.88c0,0-1.61,21.01-7.85,42.63c-1.84,6.4-4.09,12.85-6.82,18.83l-16.77-9.57 c-3.6-10.74-5.19-21.1-5.75-29.97c-1-15.87,1.3-26.96,1.3-26.96s4.88,8.22,8.59,21.67c2.74,9.95,4.84,22.76,3.86,37.23 c0.73-7.28,4.62-17.36,9.03-26.81C362.038,332.72,369.828,319.88,369.828,319.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#22A1A8"
    },
    d: "M361.978,362.51c-1.84,6.4-4.09,12.85-6.82,18.83l-16.77-9.57c-3.6-10.74-5.19-21.1-5.75-29.97 c3.04,0.61,7.17,0.17,9.89-5.29c2.74,9.95,4.84,22.76,3.86,37.23c0.73-7.28,4.62-17.36,9.03-26.81 C355.728,352.86,357.068,360.81,361.978,362.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59E2C1"
    },
    d: "M353.958,359.27c0.05,6.23-0.23,12.58-1.04,18.65l-18.83-4.26c-2.42-3.39-4.56-6.8-6.46-10.18 c-12.53-22.29-14.44-42.95-14.44-42.95s15.7,14.28,25.07,39.28c1.56,4.17,2.95,8.65,4.06,13.4c-0.73-3.66-0.89-8.26-0.67-13.26 c0.84-19.51,7.34-45.11,7.34-45.11S353.768,336.25,353.958,359.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36BEC1"
    },
    d: "M353.958,359.27c0.05,6.23-0.23,12.58-1.04,18.65l-18.83-4.26c-2.42-3.39-4.56-6.8-6.46-10.18 c6.79,1.06,9.56-1.79,10.63-3.67c1.56,4.17,2.95,8.65,4.06,13.4c-0.73-3.66-0.89-8.26-0.67-13.26 C344.768,361.46,349.898,362.95,353.958,359.27z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5A3184"
    },
    points: "369.578,369.13 367.708,376.61 364.328,390.18 359.818,408.28 331.128,408.28  325.078,384.03 322.718,374.54 321.367,369.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#462472"
    },
    points: "367.708,376.61 364.328,390.18 325.078,384.03 322.718,374.54 338.698,374.18  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.277,
    y: 369.126,
    style: {
      fill: "#7E53B7"
    },
    width: 52.851,
    height: 10.101
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M122.863,261.004c1.42,2.107,0.862,4.966-1.245,6.386c-2.107,1.42-4.966,0.862-6.386-1.245 c-1.42-2.107-0.862-4.966,1.245-6.386C118.584,258.34,121.443,258.897,122.863,261.004z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M110.428,250.693c-3.293,2.219-5.786,5.187-7.405,8.525l3.354,1.644 c1.359-2.794,3.422-5.252,6.133-7.078c2.711-1.826,5.79-2.832,8.881-3l-0.281-3.751 C117.409,247.279,113.721,248.475,110.428,250.693z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M103.977,241.118c-5.016,3.379-8.848,7.913-11.323,13.042l3.312,1.636 c2.206-4.543,5.609-8.567,10.093-11.587c4.458-3.004,9.466-4.646,14.522-4.959l-0.264-3.726 C114.651,235.915,109.018,237.722,103.977,241.118z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M97.15,230.985c-6.865,4.625-12.104,10.843-15.467,17.823l3.354,1.644 c3.103-6.437,7.888-12.127,14.195-16.377c6.308-4.25,13.379-6.546,20.51-7.004l-0.264-3.726 C111.746,223.84,104.015,226.36,97.15,230.985z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M369.833,122.837v14.29c0,5.66-4.59,10.25-10.26,10.25H332.48c-0.197,0-0.385,0.078-0.524,0.217 l-6.177,6.177c-0.467,0.467-1.265,0.136-1.265-0.524v-5.129c0-0.409-0.332-0.741-0.741-0.741h-6.959 c-5.661,0-10.25-4.589-10.25-10.25v-14.3c0-5.661,4.589-10.25,10.25-10.25h42.76C365.24,112.576,369.833,117.17,369.833,122.837 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#48215B"
    },
    cx: 328.696,
    cy: 130.416,
    r: 1.722
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#48215B"
    },
    cx: 338.198,
    cy: 130.416,
    r: 1.722
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#48215B"
    },
    cx: 347.701,
    cy: 130.416,
    r: 1.722
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.421e09f8ac92f96cf1684dd18c202f40.svg";
export { ForwardRef as ReactComponent };